export const actions = {
  PRODUCTOS_DESAYUNO_LOAD_REQUESTED: 'PRODUCTOS_DESAYUNO_LOAD_REQUESTED',
  PRODUCTOS_DESAYUNO_LOAD_SUCCEEDED: 'PRODUCTOS_DESAYUNO_LOAD_SUCCEEDED',
  PRODUCTOS_DESAYUNO_LOAD_FAILED: 'PRODUCTOS_DESAYUNO_LOAD_FAILED',

  PRODUCTOS_DESAYUNO_CATEGORIAS_REQUESTED: 'PRODUCTOS_DESAYUNO_CATEGORIAS_REQUESTED',
  PRODUCTOS_DESAYUNO_CATEGORIAS_SUCCEEDED: 'PRODUCTOS_DESAYUNO_CATEGORIAS_SUCCEEDED',
  PRODUCTOS_DESAYUNO_CATEGORIAS_FAILED: 'PRODUCTOS_DESAYUNO_CATEGORIAS_FAILED',

  PRODUCTOS_DESAYUNO_UPDATE_REQUESTED: 'PRODUCTOS_DESAYUNO_UPDATE_REQUESTED',
  PRODUCTOS_DESAYUNO_UPDATE_SUCCEEDED: 'PRODUCTOS_DESAYUNO_UPDATE_SUCCEEDED',
  PRODUCTOS_DESAYUNO_UPDATE_FAILED: 'PRODUCTOS_DESAYUNO_UPDATE_FAILED',
}

export const getProductosDesayunoLoadAction = (dispatch, filter) => {
  dispatch({
    type: actions.PRODUCTOS_DESAYUNO_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getCategoriasProductoDesayunoSelectAction = dispatch => {
  dispatch({
    type: actions.PRODUCTOS_DESAYUNO_CATEGORIAS_REQUESTED,
  })
}

export const onSubmitUpdateProductoDesayunoFormAction = (dispatch, formProducto) => {
  dispatch({
    type: actions.PRODUCTOS_DESAYUNO_UPDATE_REQUESTED,
    payload: formProducto,
  })
}
